import React from 'react';
import { Star, Quote } from 'lucide-react';

interface TestimonialCardProps {
  quote: string;
  author: string;
  role: string;
  delay: string;
}

const TestimonialCard = ({ quote, author, role, delay }: TestimonialCardProps) => {
  return (
    <div
      className="glass-card hover-lift p-8 relative animate-fade-in-up opacity-0"
      style={{ animationDelay: delay }}
    >
      <Quote className="absolute top-6 right-6 w-10 h-10 text-primary/20" />
      <div className="flex mb-4 gap-1">
        {[...Array(5)].map((_, index) => (
          <Star key={index} className="w-4 h-4 text-primary fill-primary" strokeWidth={0} />
        ))}
      </div>
      <p className="text-foreground/90 mb-6 leading-relaxed">"{quote}"</p>
      <div className="pt-4 border-t border-border/50">
        <h4 className="font-display font-bold text-foreground">{author}</h4>
        <p className="text-primary text-sm tracking-wider uppercase mt-1">{role}</p>
      </div>
    </div>
  );
};

export default TestimonialCard;
